module.exports = __webpack_public_path__ + "img/MD.3213d98b.jpg";